import { format } from 'date-fns';

const DAY_FORMAT = 'd MMM yyyy';
const DAY_AND_TIME_FORMAT = 'd MMM yyyy, HH:mm';

// A generated row is stamped at the last millisecond of its period in UTC.
// Showing that instant in local time would move it to the next day in
// timezones ahead of UTC, so the UTC calendar date is shown with no time.
function formatUtcDay(endedAt: string): string {
  const ended = new Date(endedAt);
  const utcDay = new Date(
    ended.getUTCFullYear(),
    ended.getUTCMonth(),
    ended.getUTCDate(),
  );
  return format(utcDay, DAY_FORMAT);
}

export function formatTestDate(endedAt: string, isGenerated: boolean): string {
  if (isGenerated) return formatUtcDay(endedAt);
  return format(new Date(endedAt), DAY_AND_TIME_FORMAT);
}

export function formatTestDay(endedAt: string, isGenerated: boolean): string {
  if (isGenerated) return formatUtcDay(endedAt);
  return format(new Date(endedAt), DAY_FORMAT);
}
